import { Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'

type V2LawApplicabilityDetermineSheetProps = {
  lawLabel: string
  open: boolean
  runTestDisabled: boolean
  isRunningTest: boolean
  onOpenChange: (open: boolean) => void
  onRunTest: () => void
  onAnswerManually: () => void
}

export function V2LawApplicabilityDetermineSheet({
  lawLabel,
  open,
  runTestDisabled,
  isRunningTest,
  onOpenChange,
  onRunTest,
  onAnswerManually,
}: V2LawApplicabilityDetermineSheetProps) {
  const { t } = useTranslation('common')

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className='flex w-full flex-col sm:max-w-lg'>
        <SheetHeader>
          <SheetTitle>
            {t('v2.applicability.determine.title', { law: lawLabel })}
          </SheetTitle>
          <SheetDescription>
            {t('v2.applicability.determine.description')}
          </SheetDescription>
        </SheetHeader>

        <div className='flex flex-1 flex-col gap-3 p-4'>
          <div className='rounded-lg border p-4'>
            <div className='flex items-start gap-3'>
              <Sparkles
                className='mt-0.5 size-5 shrink-0 text-primary'
                aria-hidden
              />
              <div className='min-w-0 flex-1 space-y-3'>
                <div className='space-y-1'>
                  <p className='text-sm font-medium'>
                    {t('v2.applicability.determine.runTest.title')}
                  </p>
                  <p className='text-sm text-muted-foreground'>
                    {t('v2.applicability.determine.runTest.description', {
                      law: lawLabel,
                    })}
                  </p>
                </div>
                <Button
                  type='button'
                  size='sm'
                  disabled={runTestDisabled || isRunningTest}
                  onClick={onRunTest}
                >
                  {t('v2.applicability.determine.runTest.button')}
                </Button>
              </div>
            </div>
          </div>

          <div className='rounded-lg border p-4'>
            <div className='space-y-1'>
              <p className='text-sm font-medium'>
                {t('v2.applicability.determine.manual.title')}
              </p>
              <p className='text-sm text-muted-foreground'>
                {t('v2.applicability.determine.manual.description')}
              </p>
            </div>
            <Button
              type='button'
              size='sm'
              variant='outline'
              className='mt-3'
              disabled={runTestDisabled}
              onClick={onAnswerManually}
            >
              {t('v2.applicability.determine.manual.button')}
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}
